import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { opensThread } from "@/features/agents/routes";

import { MESSAGE_PARAM, RUN_PARAM } from "../chat/useThreadDeepLink";
import { dropRouterState } from "../urlState";
import { ideLayoutStore } from "./ideLayoutStore";

/**
 * A mention, email or skill-run link, or a thread opened from the Agents
 * menu, shows the Casey panel; a reload or tab switch onto `?thread=` does
 * not. Call after the panels register.
 */
export const useShowCaseyOnLink = (): void => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const fromAgents = opensThread(location.state);
  const linked =
    fromAgents || params.has(MESSAGE_PARAM) || params.has(RUN_PARAM);
  useEffect(() => {
    if (!linked) return;
    ideLayoutStore.show("right");
    if (fromAgents) dropRouterState();
    // Once per navigation.
  }, [location.key]);
};
